<template>
  <div class="app-container">


    <el-tabs v-model="activeIndex" type="border-card" v-tab-change:activeIndex="setActiveName">
      <!-- 视频列表 -->
      <el-tab-pane label="往期回顾" name="0">
        <reviewList :init-search-value="reviewListSearchValue"/>
      </el-tab-pane>

      <!-- 视频标签 -->
      <el-tab-pane label="回顾标签" name="1">
        <reviewTabList/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import reviewList from "@/views/mai/liveReview/reviewList"
import reviewTabList from "@/views/mai/liveReview/reviewTabList"

export default {
  created() {
    this.reviewListSearchValue = this.$route.query.reviewListSearchValue
  },
  components: {
    reviewList,
    reviewTabList
  },
  data() {
    return {
      reviewListSearchValue:"",
      activeIndex:"0"
    }
  }
}
</script>

<style>
</style>
